import React, { useState } from 'react'
import { AccordianWrapper } from 'components/Owner/Plays/card-style'

import ExpandIcon from 'components/Common/SvgIcons/ExpandIcons'

const Collapseable = ({ data, children, heading, index }) => {
  let [isOpen, setIsOpen] = useState(true)
  let toggleIsOpenHandler = () => setIsOpen(!isOpen)

  return (
    <div className="Collapseable">
      {index === 0 && heading && <h6> {heading} </h6>}
      <AccordianWrapper>
        <div className={isOpen ? 'accordainInner open' : 'accordainInner close'}>
          <div className="accordainContentWrap">
            <div className="accordainContent">
              <div className={`xs:text-base lg:text-base font-semibold leading-9 text-primary`}>
                {data?.stepHeading?.title}
              </div>
              <div className={`xs:text-sm lg:text-base font-normal text-primary-text`}>
                {data?.stepHeading?.description}
              </div>
            </div>
            <div
              className="cursor-pointer arrowIcon w-[20px] m-[10px] self-start"
              onClick={toggleIsOpenHandler}
            >
              <ExpandIcon className={{}} />
            </div>
          </div>
          <div className="accordianOpenContent">{children}</div>
        </div>
      </AccordianWrapper>
    </div>
  )
}

Collapseable.defaultProps = {
  heading: '',
  index: 0,
}

export default Collapseable
